var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.0811,
    cy: 11.6465,
    r: 6,
    stroke: "#8B8C8C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0811 8.64648C10.6871 8.64648 10.297 8.72408 9.933 8.87485C9.56903 9.02561 9.23831 9.24659 8.95973 9.52516C8.68116 9.80374 8.46018 10.1345 8.30942 10.4984C8.15865 10.8624 8.08105 11.2525 8.08105 11.6465",
    stroke: "#D0D0D0",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0811 20.6465L17.0811 17.6465",
    stroke: "#8B8C8C",
    strokeLinecap: "round"
  })));
};
export default SvgSearch;